module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 menu-container"
  }, [_c('ag-grid-vue', {
    staticClass: "ag-bootstrap",
    style: (_vm.getStyle),
    attrs: {
      "gridOptions": _vm.gridOptions,
      "rowData": _vm.rowData
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-dd459c80","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/multi-select.vue
// module id = 1067
// module chunks = 0